import { defaultValueActsFilterIProps } from "~/entity/Ivideon";

export const defaultValueActsFilter: defaultValueActsFilterIProps = {
  fileName: "",
  userName: "",
  action: null,
  dateFrom: null,
  dateTo: null,
};

export const EVENT_TYPE_OPTIONS = [
  { value: "deleted", label: "Удалён" },
  { value: "generated", label: "Сформирован" },
  { value: "deaccepted", label: "Отклонен" },
  { value: "accepted", label: "Принят" },
  { value: "license_assigned", label: "Выданы лицензии" },
  { value: "expiring", label: "Истекает срок акта" },
  { value: "completed", label: "Перенесен в архив" },
];
